// Apple-inspired animation presets
const nativeSpring = {
  type: 'spring',
  stiffness: 170,
  damping: 26,
  mass: 1,
};

const nativeTransition = {
  type: 'spring',
  stiffness: 100,
  damping: 20,
  mass: 1,
};

export const pageTransition = {
  initial: {
    opacity: 0,
  },
  animate: {
    opacity: 1,
  },
  exit: {
    opacity: 0,
  },
  transition: {
    duration: 0.3,
    ease: 'easeInOut' as const,
  },
};

export const fadeIn = {
  initial: {
    opacity: 0,
  },
  animate: {
    opacity: 1,
  },
  transition: {
    duration: 0.2,
    ease: 'easeInOut' as const,
  },
};

export const slideUp = {
  initial: {
    opacity: 0,
    y: 8,
  },
  animate: {
    opacity: 1,
    y: 0,
  },
  transition: {
    duration: 0.3,
    ease: 'easeInOut' as const,
  },
};

export const staggerContainer = {
  animate: {
    transition: {
      staggerChildren: 0.05,
    },
  },
};

export const cardHover = {
  scale: 1.01,
  transition: {
    duration: 0.2,
    ease: 'easeInOut' as const,
  },
};

export const buttonTap = {
  scale: 0.98,
  transition: {
    duration: 0.1,
    ease: 'easeInOut' as const,
  },
};

export const listItem = {
  initial: {
    opacity: 0,
    x: -8,
  },
  animate: {
    opacity: 1,
    x: 0,
  },
  transition: {
    duration: 0.2,
    ease: 'easeInOut' as const,
  },
};

export const modalTransition = {
  initial: {
    opacity: 0,
    scale: 0.98,
  },
  animate: {
    opacity: 1,
    scale: 1,
  },
  exit: {
    opacity: 0,
    scale: 0.98,
  },
  transition: {
    duration: 0.3,
    ease: 'easeInOut' as const,
  },
};

export const glassCard = {
  initial: {
    opacity: 0,
  },
  animate: {
    opacity: 1,
  },
  whileHover: {
    scale: 1.01,
    transition: {
      duration: 0.2,
      ease: 'easeInOut' as const,
    },
  },
  transition: {
    duration: 0.3,
    ease: 'easeInOut' as const,
  },
};

export const iconHover = {
  scale: 1.05,
  transition: {
    duration: 0.2,
    ease: 'easeInOut' as const,
  },
};

export const textReveal = {
  initial: {
    opacity: 0,
    y: 8,
  },
  animate: {
    opacity: 1,
    y: 0,
  },
  transition: {
    duration: 0.3,
    ease: 'easeInOut' as const,
  },
};

export const shimmerEffect = {
  initial: {
    opacity: 0.6,
  },
  animate: {
    opacity: 1,
  },
  transition: {
    duration: 1,
    ease: 'easeInOut' as const,
    repeat: Infinity,
    repeatType: 'reverse',
  },
};
